import { useState } from "react";
import { faqList } from "@/mocks/comics";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  return (
    <section id="faq" className="bg-secondary-100/60 py-14 md:py-20">
      <div className="mx-auto max-w-page px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-accent-100 px-4 py-1.5 text-xs font-bold text-accent-800 md:text-sm">
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl">关于免费版，你想知道的都在这里</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            我们整理了读者最常问的几个问题，点击即可展开答案，快速帮你上手。
          </p>
        </div>

        <div className="mx-auto mt-10 max-w-3xl space-y-3 md:mt-12">
          {faqList.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border transition-colors ${
                  isOpen ? "border-primary-300 bg-background-50" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                >
                  <span className="text-sm font-bold md:text-base">
                    <i className="mr-2 text-primary-500 ri-question-mark"></i>
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-lg text-foreground-600 transition-transform duration-300 ${
                      isOpen ? "rotate-180 text-primary-500" : ""
                    } ri-arrow-down-s-line`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4 md:px-6">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}